(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency,currencyDisplay:'narrowSymbol'}).format(cents / 100) + ' ' + currency;
  const updateShipping = cart => {
    if (!cart) return;
    document.querySelectorAll('[data-vcd-shipping]').forEach(box => {
      const currency = cart.currency || box.dataset.currency;
      const goal = Number(box.dataset.goal);
      const text = box.querySelector('[data-vcd-shipping-text]');
      const track = box.querySelector('[role="progressbar"]');
      if (currency !== box.dataset.currency) {
        text.textContent = box.dataset.other.replace('[amount]', money(goal,box.dataset.currency));
        track.hidden = true;
        return;
      }
      const remaining = Math.max(0,goal - cart.total_price);
      const progress = Math.max(0,Math.min(100,cart.total_price / goal * 100));
      text.textContent = remaining ? box.dataset.remaining.replace('[amount]',money(remaining,currency)) : box.dataset.complete;
      track.hidden = false;
      track.setAttribute('aria-valuenow',String(Math.round(progress)));
      track.firstElementChild.style.width = `${progress}%`;
      box.querySelector('[data-vcd-goal]').textContent = money(goal,currency);
    });
  };
  class ViloraCartProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-vcd-open]');
      this.button = this.querySelector('[data-vcd-add]');
      this.error = this.querySelector('[role="alert"]');
      this.variants = [...this.querySelectorAll('[data-vcd-variant-data]')].map(node => ({id:Number(node.dataset.id),options:JSON.parse(node.dataset.options),available:node.dataset.available === 'true',price:node.dataset.price,image:node.dataset.image}));
      this.options = [...this.querySelectorAll('[data-vcd-option-index]')];
      this.selected = Array(this.options.length).fill(null);
      this.trigger.addEventListener('click',()=>{this.error.hidden=true;this.update();this.dialog.showModal();});
      this.querySelector('.vcd-picker__close').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('close',()=>{if(this.trigger.isConnected)this.trigger.focus({preventScroll:true});});
      this.dialog.addEventListener('click',event=>{
        if(event.target!==this.dialog)return;
        const b=this.dialog.getBoundingClientRect();
        if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)this.dialog.close();
      });
      this.querySelectorAll('[data-vcd-option]').forEach(choice=>choice.addEventListener('click',()=>{
        this.selected[Number(choice.dataset.vcdOption)]=choice.dataset.value;
        this.error.hidden=true;
        this.update();
      }));
      this.button.addEventListener('click',()=>this.add());
      this.update();
    }
    update() {
      this.options.forEach((group,index)=>{
        group.querySelector('[data-vcd-selection]').textContent=this.selected[index]||group.dataset.choose||'—';
      });
      this.querySelectorAll('[data-vcd-option]').forEach(choice=>{
        const index=Number(choice.dataset.vcdOption);
        const possible=this.variants.some(variant=>variant.available&&variant.options[index]===choice.dataset.value&&this.selected.every((value,i)=>i===index||!value||variant.options[i]===value));
        choice.disabled=!possible;
        choice.setAttribute('aria-pressed',String(this.selected[index]===choice.dataset.value));
      });
      const complete=this.selected.every(Boolean);
      this.variant=complete ? this.variants.find(v=>v.available&&(this.options.length===0||v.options.every((value,index)=>value===this.selected[index]))) : null;
      const preview=this.variant||this.variants.find(v=>v.available&&this.selected.every((value,index)=>!value||v.options[index]===value));
      if(preview){this.querySelector('[data-vcd-price]').textContent=preview.price;if(preview.image){const img=this.querySelector('.vcd-picker__image img');if(img){img.src=preview.image;img.removeAttribute('srcset');}}}
      this.button.disabled=!this.variant||this.busy;
      this.querySelector('[data-vcd-status]').textContent=this.variant?'':this.dataset.choose;
    }
    async add() {
      if(!this.variant||this.busy)return;
      this.busy=true;this.button.disabled=true;this.button.textContent=this.dataset.adding;this.error.hidden=true;
      let added=false;
      try {
        const response=await fetch(root()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:1}]})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||this.dataset.error);
        added=true;
        this.dialog.close();
        const cartResponse=await fetch(root()+'cart.js',{headers:{Accept:'application/json'}});
        if(!cartResponse.ok)throw new Error(this.dataset.error);
        const cart=await cartResponse.json();
        const themeCart=window.MinimogTheme?.Cart;
        if(themeCart?.renderNewCart){themeCart.cart=cart;await themeCart.renderNewCart();themeCart.updateCartCount?.(cart);themeCart.openCartDrawer?.();window.MinimogEvents?.emit('ON_CART_UPDATE',cart);}
        else {
          const response=await fetch(root()+'?section_id=cart-drawer');
          if(!response.ok)throw new Error(this.dataset.error);
          const html=new DOMParser().parseFromString(await response.text(),'text/html');
          const drawer=document.querySelector('.scd__wrapper');
          for(const selector of ['.scd__body','.scd__summary']){const fresh=html.querySelector(selector);const old=drawer?.querySelector(selector);if(fresh&&old)old.replaceWith(fresh);}
          document.querySelectorAll('.sf-cart-count').forEach(count=>count.textContent=cart.item_count);
        }
        updateShipping(cart);
      } catch(failure) {
        this.error.textContent=added?this.dataset.refreshError:failure.message||this.dataset.error;
        this.error.hidden=false;
        if(added&&this.isConnected)this.dialog.showModal();
      } finally {
        this.busy=false;
        if(this.isConnected){this.button.disabled=added||!this.variant;this.button.textContent=added?this.dataset.added:this.dataset.add;}
      }
    }
  }
  if (!customElements.get('vilora-cart-product')) customElements.define('vilora-cart-product',ViloraCartProduct);
  document.addEventListener('click',event=>{
    const arrow=event.target.closest('[data-vcd-scroll]');
    if(!arrow)return;
    const rail=arrow.closest('.vcd-recommendations').querySelector('.vcd-recommendations__rail');
    rail.scrollBy({left:Number(arrow.dataset.vcdScroll)*rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  });
  if(window.MinimogEvents?.subscribe){
    window.MinimogEvents.subscribe('ON_CART_UPDATE',updateShipping);
    window.MinimogEvents.subscribe('ON_OPEN_DRAWER_CART',updateShipping);
  }
})();


